/**
 * Pricing for items on a crew member's kit list (default_equipment).
 */

/**
 * Base rate and markup for one item on a crew member's kit list.
 *
 * A blank or missing markup means "use the crew member's default"; any number,
 * including 0, is used as-is. A kit item with 0 markup is a real 0 - the
 * `x || default` form let it fall through to the default. Mirrors `_kit_rate`
 * in backend/treatment_service.py.
 */
export function kitItemPricing(item, crew) {
  const defaultMarkup = Number(crew?.default_markup_percent) || 0;
  const baseRate = parseFloat(item?.rate) || 0;
  const raw = item?.markup_percent;
  const parsed = parseFloat(raw);
  const markup = raw === '' || raw == null || Number.isNaN(parsed) ? defaultMarkup : parsed;
  return { baseRate, markup };
}
